// src/App.tsx
import { BrowserRouter } from "react-router-dom";
import type { ComponentType } from "react";
import AppShell from "./AppShell";

type Props = { preloaded?: { path: string; Component: ComponentType } };

export default function App({ preloaded }: Props) {
  return (
    <BrowserRouter>
      <AppShell preloaded={preloaded} />
    </BrowserRouter>
  );
}
